import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import {FIELDS} from '../useContactSellerState/reducer.js'
import useContactSellerFormContext from './useContactSellerFormContext.js'

export const useChecksAndValidations = ({isUseZipCode = false} = {}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {PRIVATE_CONTRACT_ID} = config.get('dealer')
  const phoneRegex = config.get('REGEX_PHONE')
  const emailRegex = config.get('REGEX_EMAIL')
  const zipCodeRegex = config.get('REGEX_SPAIN_POSTALCODE')

  const regExpPhoneValidation = new RegExp(phoneRegex)
  const regExpEmailValidation = new RegExp(emailRegex)
  const regExpZipcodeValidation = new RegExp(zipCodeRegex)

  const isHigherThanTabletResolution = useMediaQuery(useMediaQueryBreakpoints.lg)

  const {currentProps, state} = useContactSellerFormContext()
  const {
    adId,
    buttonCallSeller,
    contractId,
    hasFinancingData,
    showLabels,
    showReservationMainCTA,
    showSellerCallLinkButton
  } = currentProps

  const hasAdId = Boolean(adId)
  const isDealer = Number(contractId) !== PRIVATE_CONTRACT_ID
  const checkIsEmptyString = string => string === ''

  const hasEmailValidSyntax = email => regExpEmailValidation.test(email)
  const hasPhoneValidSyntax = phone => regExpPhoneValidation.test(phone)
  const hasValidZipcodeSyntax = zipCode => regExpZipcodeValidation.test(zipCode)

  const checkIsValidZipcode = zipCode => !checkIsEmptyString(zipCode) && hasValidZipcodeSyntax(zipCode)
  const checkIsValidEmail = email => !checkIsEmptyString(email) && hasEmailValidSyntax(email)
  const checkIsValidPhone = phoneNumber => {
    // Phone is an optional field. So or it's empty or if filled it must have the right format
    const isEmptyPhone = checkIsEmptyString(phoneNumber)
    return isEmptyPhone || (!isEmptyPhone && hasPhoneValidSyntax(phoneNumber))
  }
  const isValidName = !checkIsEmptyString(state[FIELDS.NAME.NAME].value)
  const isValidEmail = checkIsValidEmail(state[FIELDS.EMAIL.NAME].value)
  const isValidPhone = checkIsValidPhone(state[FIELDS.PHONE.NAME].value)

  const hasAcceptedTermsAndConditions = state[FIELDS.TERMS_AND_CONDITIONS.NAME].value
  const isValidZipcode =
    !isUseZipCode ||
    checkIsEmptyString(state[FIELDS.ZIPCODE.NAME].value) ||
    checkIsValidZipcode(state[FIELDS.ZIPCODE.NAME].value)

  const hasSuccessfulCaptcha = state.hasCaptcha && !state.hasSuccessfulCaptcha

  const areFormFieldsValid = () => {
    return isValidName && isValidEmail && isValidPhone && isValidZipcode && hasAcceptedTermsAndConditions
  }

  const fieldChecker = {
    name: isValidName,
    email: isValidEmail,
    phone: isValidPhone,
    zipCode: isValidZipcode,
    terms_and_conditions: hasAcceptedTermsAndConditions,
    contact_last_call_on_mail_contact: true // This field is always valid (optional)
  }

  const checkValidField = fieldName => fieldChecker[fieldName]

  const showSellerCallLink = buttonCallSeller && showSellerCallLinkButton && !isDealer && !showReservationMainCTA

  const showFormFieldLabel = showLabels
  const showTermsAndConditions = state[FIELDS.TERMS_AND_CONDITIONS.NAME].isShown

  return {
    areFormFieldsValid,
    checkValidField,
    hasAdId,
    hasFinancingData,
    hasSuccessfulCaptcha,
    isDealer,
    isHigherThanTabletResolution,
    isValidEmail,
    isValidName,
    isValidPhone,
    isValidZipcode,
    showFormFieldLabel,
    showSellerCallLink,
    showTermsAndConditions
  }
}
